module.exports = __webpack_public_path__ + "media/images/brand/main_nav/cow_grill_500-e7b8d3537633ce06e66f3a3ec64a61b1.png";